import { ThemeContextProvider, useThemeMode } from "@connected-repo/ui-mui/theme/ThemeContext";
import { router } from "@superadmin/router";
import { RouterProvider } from "react-router";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function ToastProvider() {
	// Not `mode`: it can be "system", which Toastify has no theme for.
	const { actualMode } = useThemeMode();
	return <ToastContainer position="top-right" autoClose={4000} theme={actualMode} />;
}

export default function App() {
	return (
		<ThemeContextProvider>
			<RouterProvider router={router} />
			<ToastProvider />
		</ThemeContextProvider>
	);
}
